import Newmaintenancekindform from './new_maintenance_kind_form.vue'
import maintenanceKindDetail from './maintenance-kind-detail.vue';
export default{
  Newmaintenancekindform,
  'maintenance-kind-detail': maintenanceKindDetail
}